// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"388":"c20ed1d4","471":"20a4a351","851":"a7c9acbe","882":"796657b3","906":"3afdafa0","928":"0783ed03"}[chunkId] + ".css";
};